/* eslint-disable import/no-default-export */
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { default as de, default as deTranslation } from './translation/de.json';
import { default as en, default as enTranslation } from './translation/en.json';

declare module 'react-i18next' {
    interface CustomTypeOptions {
        defaultNS: 'common';
        returnNull: false;
        resources: { en: typeof en; de: typeof de };
    }
}

void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        detection: {
            order: ['localStorage', 'navigator'], // provides translation for users browser language, if available
            caches: ['localStorage'],
        },
        debug: false,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: { translation: enTranslation },
            de: { translation: deTranslation },
        },
    });

export default i18n;
